export const isUncertainSex = (sex: string | null | undefined): boolean => {
  if (sex == null) return true;

  const normalizedSex = sex.trim().toLowerCase();
  return normalizedSex === '' || normalizedSex === 'unsure' || normalizedSex === 'unknown';
};
